/**
 * LOINC codes for HbA1c (Hemoglobin A1c) control observations
 * Used for HEDIS CDC (Comprehensive Diabetes Care) measure - HbA1c Control
 * Excludes: 86910-7 (A1c goal documentation, not a lab result)
 *           43150-2 (device panel, not a discrete lab result)
 */
export const HBA1C_CONTROL_LOINC_CODES = [
  "4548-4", // Hemoglobin A1c/Hemoglobin.total in Blood
  "4549-2", // Hemoglobin A1c/Hemoglobin.total in Blood by Electrophoresis
  "4584-4", // Hemoglobin A1c/Hemoglobin.total
  "17855-8", // Hemoglobin A1c/Hemoglobin.total in Blood by calculation
  "17856-6", // Hemoglobin A1c/Hemoglobin.total in Blood by HPLC
  "41995-2", // Hemoglobin A1c [Mass/volume] in Blood
  "55454-3", // Hemoglobin A1c in Blood
  "59261-8", // Hemoglobin A1c/Hemoglobin.total in Blood by IFCC protocol
  "62388-4", // Hemoglobin A1c/Hemoglobin.total in Blood by JDS/JSCC protocol
  "71875-9", // Hemoglobin A1c/Hemoglobin.total [Pure mass fraction] in Blood
  "96595-4", // Hemoglobin A1c/Hemoglobin.total in DBS (dried blood spot)
];

/**
 * SNOMED CT codes for HbA1c (Hemoglobin A1c) control
 * Used for HEDIS CDC (Comprehensive Diabetes Care) measure - HbA1c Control
 */
export const HBA1C_CONTROL_SNOMED_CODES = [
  "43396009", // Hemoglobin A1c measurement (procedure)
];

/**
 * CPT codes for HbA1c control
 * Excludes: 83020/83021 (general hemoglobin fractionation, not A1c-specific),
 *           80048/80053/85025 (metabolic/CBC panels — not A1c tests),
 *           36415 (venipuncture — specimen collection, not the test itself),
 *           99000 (specimen handling/conveyance),
 *           3044F (quality measure registry code, not a lab order)
 */
export const HBA1C_CONTROL_CPT_CODES = [
  "83036", // Hemoglobin; glycosylated (A1C)
  "83037", // Hemoglobin; glycosylated (A1C) by FDA-cleared home use device
];
